import { render, staticRenderFns } from "./MinimizedVideo.vue?vue&type=template&id=45e9b1ee&scoped=true"
import script from "./MinimizedVideo.vue?vue&type=script&lang=ts"
export * from "./MinimizedVideo.vue?vue&type=script&lang=ts"
import style0 from "./MinimizedVideo.vue?vue&type=style&index=0&id=45e9b1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e9b1ee",
  null
  
)

export default component.exports